import { DateTime } from 'luxon';
import * as React from 'react';

interface IDateText {
  time: string | null;
}

const TimeText: React.FunctionComponent<IDateText> = (props) => {
  const getDateTime = (time: string | null): DateTime | null => {
    return time !== null && DateTime.fromISO(time).isValid ? DateTime.fromFormat(time, 'hh:mm:ss') : null;
  };
  return getDateTime(props.time) === null ? (
    <span>None</span>
  ) : (
    <span>{getDateTime(props.time)!.toLocaleString(DateTime.TIME_SIMPLE)}</span>
  );
};

export default TimeText;
